import { useCallback, useRef, useState } from 'react'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'

// CSV ファイルの最大サイズ（50MB）
const MAX_SIZE = 50 * 1024 * 1024

export const useFileSelection = () => {
  const { showErrorSnackbar } = useSnackbar()
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)

  const handleFileSelect = useCallback(() => {
    fileInputRef.current?.click()
  }, [])

  const handleFileChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0]
      if (file) {
        // ファイルサイズチェック
        if (file.size > MAX_SIZE) {
          showErrorSnackbar(
            'ファイルサイズが50MBを超えているためアップロードできません',
          )
          if (fileInputRef.current) {
            fileInputRef.current.value = ''
          }
          return
        }

        // CSVファイルかどうかをチェック
        if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
          setSelectedFile(file)
        } else {
          showErrorSnackbar('CSVファイルを選択してください')
          // ファイル選択をリセット
          if (fileInputRef.current) {
            fileInputRef.current.value = ''
          }
        }
      }
    },
    [setSelectedFile, showErrorSnackbar],
  )

  const resetFile = useCallback(() => {
    setSelectedFile(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }, [])

  return {
    fileInputRef,
    selectedFile,
    handleFileSelect,
    handleFileChange,
    resetFile,
  }
}
